module.exports = __webpack_public_path__ + "img/20200513_160656.4730eac9.jpg";